import { ApiProvider } from 'providers/request'
import { normalizeTrafficData, TrafficData } from 'models/traffic'
import { UrlUtils } from 'utils/url'
import { coordinatesToLngLat } from 'utils/coordinates'

export const TrafficRepository = {
  fetch(coordinates: number[]): Promise<TrafficData> {
    const queryString = UrlUtils.formatQueryParams(coordinatesToLngLat(coordinates))
    return ApiProvider.get(`/traffic_data?${queryString}`).then(normalizeTrafficData)
  },
}
